import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Component({
    selector: 'app-slit-valve-seal',
    templateUrl: './slit-valve-seal.component.html',
    styleUrls: [
        './slit-valve-seal.component.scss',
    ],
    standalone: false
})
export class SlitValveSealComponent implements OnInit {
  constructor(
    private meta: Meta,
  ) {
    this.meta.updateTag({name: "search-title", class: "swiftype", content: "Slit Valve Seal", "data-type": "string"});
  }

  ngOnInit() {
  }

}
